module.exports = __webpack_public_path__ + "img/1f60f.33b72bd.svg";